<template>
	<div class="drawer">
		<el-drawer
		size="800px"
		title="洗美详情"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<div>
				<!-- <el-row style="padding:40px 20px 0;float: none;font-size: 14px;">
					<el-col :span="6">
						<el-button type="danger" @click="stop(msg)" size="mini">结束所有宠物寄养</el-button>
					</el-col>
				</el-row> -->
				<el-row class="row">
					<el-col :span="12">
						<span class="label">顾客：</span>
						<span class="value">{{msg.memberName}}</span>
					</el-col>
					<el-col :span="12">
						<span class="label">手机号：</span>
						<span class="value">{{msg.memberMobile}}</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">总计：</span>
						<span class="value">{{msg.totalMoney}} 元</span>
					</el-col>
					<el-col :span="12" style="height: 12px;">
						<span class="label"></span>
						<span class="value" >
							<el-button v-if="msg.isPay===true&&msg.status===1" type="danger" @click="stop" size="mini" style="margin-top:-12px;">完成洗美服务</el-button>
						</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">创建人：</span>
						<span class="value">
							{{msg.createUserName}}
						</span>
					</el-col>
					<el-col :span="12">
						<span class="label">备注：</span>
						<span class="value">{{msg.remark}}</span>
					</el-col>
				</el-row>
			</div>
			<div style="border-top:1px solid #eee;padding:5px 0;" v-for="(item,index) in msg.pets" :key="index">
				<el-row class="row">
					<el-col :span="12">
						<span class="label" style="width:80px;">第 {{index+1}} 只宠物：</span>
						<span class="value">{{item.petName}}</span>
					</el-col>
					<!-- <el-col :span="15">
						<span class="label">洗美间：</span>
						<span class="value">
							<span v-for="(cagesItem,cagesIndex) in item.cages" :key="cagesIndex">{{cagesItem.name+' '}}</span>
						</span>
					</el-col> -->
				</el-row>
				<el-row class="row">
					<el-col :span="6">
						<span class="label">种类：</span>
						<span class="value">{{item.className}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">品种：</span>
						<span class="value">{{item.typeName}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">性别：</span>
						<span class="value">{{item.sex}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">体重：</span>
						<span class="value">{{item.weight}} kg</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="24">
						<span class="label">备注：</span>
						<span class="value">{{item.remark}}</span>
					</el-col>
				</el-row>
				<div style="padding:10px 0px 0;float: none;font-size: 14px;">
					<el-table :data="item.goodsList" height="100%" style="width: 100%">
						<el-table-column label="名称" width="140">
							<template slot-scope="scope">
								{{scope.row.goodsName}}
							</template>
						</el-table-column>
						<el-table-column label="规格">
							<template slot-scope="scope">
								{{scope.row.skuValue}}
							</template>
						</el-table-column>
						<el-table-column label="活动/洗美卡">
							<template slot-scope="scope">
								{{scope.row.activityName}}
							</template>
						</el-table-column>
						<el-table-column label="单价" width="70">
							<template slot-scope="scope">
								{{scope.row.price}}
							</template>
						</el-table-column>
						<el-table-column label="数量" width="50">
							<template slot-scope="scope">
								{{scope.row.num}}
							</template>
						</el-table-column>
						<el-table-column label="单位" width="50">
							<template slot-scope="scope">
								{{scope.row.unit}}
							</template>
						</el-table-column>
						<el-table-column label="总价" width="80">
							<template slot-scope="scope">
								{{scope.row.totalMoney}}
							</template>
						</el-table-column>
						<el-table-column label="销售人员" width="150">
							<template slot-scope="scope">
								<el-select
								v-model="scope.row.salesMans"
								:key="scope.row.goodsName+scope.row.skuValue"
								:disabled="msg.isPay===false||msg.status===2"
								multiple filterable
								placeholder="请选择"
								size="mini"
								style="width:120px;margin-bottom:20px;">
									<el-option v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name"
									:value="item._id+','+item.basic_info.nick_name"></el-option>
								</el-select>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				msg:{},
				staffList:[]
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
		},
		props:{
			curItem:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus=true
				this.getGoodsMsg(this.curItem.washRecordId)
				this.getStaffList();
			})
		},
		methods: {
			handleClose(){
				this.$emit('submit')
			},
			stop(){
				let finishList = [];
				for(let b=0;b<this.msg.pets.length;b++){
					for(let i=0;i<this.msg.pets[b].goodsList.length;i++){
						let finishItem = {
							goodsItemsId:this.msg.pets[b].goodsList[i].itemsId,
							salesMans:[],
						}
						for(let a=0;a<this.msg.pets[b].goodsList[i].salesMans.length;a++){
							if(this.$public.isNull(this.msg.pets[b].goodsList[i].salesMans[a])){
								this.$message({
									message: '请输入销售人员！',
									type: 'error'
								});
								return ;
							}
							finishItem.salesMans.push({
								"userId": this.msg.pets[b].goodsList[i].salesMans[a].split(',')[0],
								"userName": this.msg.pets[b].goodsList[i].salesMans[a].split(',')[1],
							})
						}
						finishList.push(finishItem)
					}
				}
				
				this.$confirm('确定已经完成全部洗美服务?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						"serviceId": this.msg.washRecordId,
						finishItem:finishList,
					}
					let loading = this.$loading()
					this.$http.post('/api/WashBeauty/Complete', params).then(res => {
						loading.close()
						if (res.code == 0) {
							this.$message({
								message: '操作成功！已经生成洗美订单，请注意查看',
								type: 'success'
							});
							this.$emit('submit')
						}
					})
				})
			},
			// 获取商品信息
			getGoodsMsg(washRecordId) {
				let loading = this.$loading()
				this.$http.get('/api/WashBeauty/Detail', {
					serviceId: washRecordId
				}).then(res=>{
					loading.close();
					if(res.code===0){
						this.msg = res.data;
						for(let b=0;b<this.msg.pets.length;b++){
							for(let i=0;i<this.msg.pets[b].goodsList.length;i++){
								let arr = []
								for(let a=0;a<this.msg.pets[b].goodsList[i].salesMans.length;a++){
									let man = this.msg.pets[b].goodsList[i].salesMans[a];
									arr.push(man.userId+','+man.userName)
								}
								this.msg.pets[b].goodsList[i].salesMans = arr;
							}
						}
					}
				})
			},
			getStaffList() {
				let params = {
					"keyword": '',
					"pageIndex": 1,
					"pageSize": 500,
				}
				this.$http.get('/api/Staff/BathStaffList', params).then(res => {
					if (res.code == 0) {
						this.staffList = res.data.data;
					}
				})
			},
		},
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.el-drawer__body{
				overflow: auto;padding:0 0 50px;
			}
			
		}
		.row{
			padding:14px 20px 14px;float: none;font-size: 20px;font-size: 12px;color:#666;
			.label{
				display: inline-block;width:60px;text-align: right;
			}
		}
	}
	
</style>
